export class NegateBack {
    constructor(input) {
        this.input = input;
    }
    backward(grad) {
        const gradIn = grad.negate();
        const needed = this.input.backward(gradIn);
        if (!needed) {
            gradIn.delete();
        }
    }
    delete() {
        if (!this.input.isLeaf()) {
            this.input.delete();
        }
    }
}
//# sourceMappingURL=negateBack.js.map